<template>
  <div class="relative">
    <!-- <filterbar currentView="map"></filterbar> -->
    <div class="pt-[80px]">
      <div
        class="max-w-md z-[5] relative bg-white dark:bg-opacity-70 backdrop-blur-xl dark:bg-neutral-900 dark:backdrop-blur-xl dark:text-white dark:bg-opacity-70">
        <div role="status" v-for="(item, $index) in list" :key="$index"
          class="w-full w-full bg-white dark:bg-neutral-900 hover:bg-gray-100 dark:hover:bg-neutral-800 shadow transition text-gray dark:text-white duration-300 animate-in fade-in ">
          <transition name="fade">
            <a v-bind:href="`${currentUrl}/accomodations/${item.id}?${params}`" class="flex justify-between h-full p-4">
              <div class="flex items-center relative justify-center h-[140px] w-[160px] mb-2 mr-4">
                <vue-load-image class="w-full h-full">
                  <img slot="image" v-bind:src="mipmap(item.spotlightimage, 400)" alt=""
                    class="w-full h-full text-gray-200 object-cover shadow-lg rounded-2xl animate-in fade-in transition duration-300" />
                  <div slot="preloader"
                    class="w-full h-full object-cover animate-in fade-in duration-300 blur-lg bg-gray-300 dark:bg-neutral-700 rounded-2xl">
                  </div>
                </vue-load-image>
                <div
                  v-if="item.prices && item.prices.priceperNight / item.prices.multiplier < 99999 && !item.prices.priceperNight < 1 && item.prices.multiplier != 1 && item.prices.multiplier != 100"
                  class="absolute left-2 top-2 px-4 h-10 flex justify-center items-center bg-black bg-opacity-50 text-gray-100 backdrop-blur-sm shadow-lg text-sm rounded-full">
                  <div class="flex justify-center items-center" v-if="item.prices.priceperNight / item.prices.multiplier >
                    item.prices.priceperNight">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill=currentColor
                      viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                    </svg>
                    {{ $t('Price drop!') }}
                  </div>
                  <div
                    v-else-if="item.prices && item.prices.priceperNight / (item.prices.multiplier / 100) < item.prices.priceperNight">
                    {{ $t('Popular!') }} </div>
                </div>
                <likebutton :id="item.id" background="bg-black bg-opacity-50 backdrop-blur-sm" color="text-gray-100">
                </likebutton>
              </div>
              <div class="flex flex-col py-2 gap-4 justify-center flex-1">
                <div class="pr-2 flex flex-col justify-center items-start">
                  <h4 class="mb-1 font-bold text-base leading-4 break-word">{{ item.name.split(",")[0] }}</h4>
                  <div class="flex items-center">
                    <span class="h-3 w-4 mr-1" v-bind:class="'fi fi-' + item.country.toLowerCase()">
                    </span>
                    <span class="text-sm leading-5">{{ item.city }}</span>
                  </div>
                </div>
                <div class="flex flex-col gap-4 justify-center items-start">
                  <h5 v-if="item.prices && item.prices.price">
                    <span class="font-bold">€{{ item.prices.price.toFixed(2) }} </span>
                  </h5>
                  <div class="font-bold text-base leading-4" v-if="item.score">
                    <div class="flex items-center">
                      <svg class="w-4 h-4 text-primary mr-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor" viewBox="0 0 22 20">
                        <path
                          d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                      </svg>
                      <p class="text-sm font-bold text-gray-900">4.95</p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </transition>
        </div>
        <infinite-loading @infinite="infiniteHandler" class="w-full">
          <div slot="spinner" class="flex flex-col justify-start w-full transition duration-300 animate-in">
            <div role="status" v-for="n in Object.keys(list).length == 0 ? 12 : Object.keys(list).length == 4 ? 8 : 4"
              class="pt-4 px-2 rounded animate-pulse md:pt-4 md:px-4 mb-4 w-full"
              :class="{ 'opacity-0': Object.keys(list).length >= 12 }">
              <div class="flex items-center justify-center h-48 mb-2 bg-gray-300 dark:bg-neutral-700 blur-lg rounded-2xl">
                <svg class="w-10 h-10 text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 16 20">
                  <path
                    d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                  <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                </svg>
              </div>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">No results message</div>
        </infinite-loading>
      </div>
    </div>
    <div class="absolute z-0  top-0 h-[100%] left-0 right-0">
      <div class="sticky top-0 left-[28rem]"
        :class="[currentZoom > 13.2 ? currentZoom > 14.4 ? currentZoom > 17.5 ? 'map_level_4' : 'map_level_3' : 'map_level_2' : 'map_level_1']">
        <div v-if="JSON.parse($attrs.locations).length"
          class="w-[calc(100vw-28rem)] overflow-x-scroll absolute pl-4 pb-4 bottom-0 left-[28rem] z-[1] flex gap-2 text-xs">
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-gray-700 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('all')"
            :class="[activeLocationFilter.length == 0 ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-4" icon="show"></svg-vue></div>
            <div class="">{{ $t('All') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-gray-700 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('listings')"
            :class="[activeLocationFilter.includes('listings') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-4" icon="propTypes/House"></svg-vue></div>
            <div class="">{{ $t('Listings') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-indigo-400 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('must_see')"
            :class="[activeLocationFilter.includes('must_see') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-3" icon="camera"></svg-vue></div>
            <div class="">{{ $t('Must see') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-amber-500 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('food_and_drinks')"
            :class="[activeLocationFilter.includes('food_and_drinks') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-3" icon="food"></svg-vue></div>
            <div class="">{{ $t('Food and Drinks') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-rose-400 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('amusement')"
            :class="[activeLocationFilter.includes('amusement') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-3" icon="amusement"></svg-vue></div>
            <div class="">{{ $t('Amusement') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-yellow-500 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('shopping')"
            :class="[activeLocationFilter.includes('shopping') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-3" icon="shopping"></svg-vue></div>
            <div class="">{{ $t('Shopping') }}</div>
          </div>
          <div
            class="bg-white px-3 py-2 rounded-full shrink-0 text-blue-400 flex gap-2 items-center shadow-lg hover:scale-105 transition cursor-pointer"
            @click="addOrRemoveFilter('parking')"
            :class="[activeLocationFilter.includes('parking') ? 'bg-neutral-900 text-white' : '']">
            <div class=""><svg-vue class="h-3" icon="parking"></svg-vue></div>
            <div class="">{{ $t('Parking') }}</div>
          </div>
        </div>
        <l-map ref="map" v-if="receivedAccos" class="map !h-screen w-full sticky top-0 z-0 dark:bg-neutral-900"
          :zoom="defaultPos[2]" @zoomThreshold="zoomUpdated" @update:zoom="zoomUpdated"
          :options="{ zoomControl: false, scrollWheelZoom: false, smoothWheelZoom: true, smoothSensitivity: 6 }"
          :center="[defaultPos[0], defaultPos[1]]" :max-zoom="maxZoom" :min-zoom="minZoom">
          <l-tile-layer :url="$dark ? darkurl : url" :attribution="attribution" :accessToken="accessToken"
            :options="{ maxZoom: maxZoom }"></l-tile-layer>

          <v-marker-cluster ref="cluster" :options="clusterOptions">
            <l-marker v-for="(item, index) in markers" :key="'marker-' + index"
              v-if="activeLocationFilter.length == 0 || activeLocationFilter.includes('listings')" :options="{
                price: item['price'] ? item['price'].toFixed(0) : 0,
                type: item['propertyType']
              }" :lat-lng="[item['latitude'], item['longitude']]"
              @click="scrollMarker(item['id']), showMarkerByIndex = null">
              <l-icon :icon-anchor="staticAnchor" class-name="markerClass accoClass !mt-0 !ml-0">
                <div v-if="item['price']" :data-price="item['price'].toFixed(0)"
                  class="bg-white shadow-md border border-gray-300 py-1 -translate-x-4 px-2 rounded-full text-xs text-nowrap whitespace-nowrap"
                  :id="'marker-' + item['id']" v-bind:class="{
                    active: showMarkerByIndex === item['id'],
                  }">
                  € {{ item['price'].toFixed(0) }}
                </div>
                <div v-else :data-price="0"
                  class="bg-white shadow-md border border-gray-300 py-1 -translate-x-4 px-2 rounded-full text-xs"
                  :id="'marker-' + item['id']" v-bind:class="{
                    active: showMarkerByIndex === item['id'],
                  }">{{ item['propertyType'] }}
                </div>
              </l-icon>

              <l-popup :options="{
                maxWidth: 400
              }">
                <a :href="`${currentUrl}/accomodations/${item.id}?${params}`">
                  <div class="flex flex-col justify-between items-start w-full">
                    <img v-bind:src="mipmap(item['image'], 200)" alt="" loading="lazy"
                      class="w-full h-40 rounded-t-lg text-gray-200 object-cover" srcset="" />
                    <div class="flex justify-between items-end gap-2 w-full p-3">
                      <div class="flex flex-col">
                        <div class="text-sm text-gray-600">{{ item['name'] }}</div>
                        <div class="text-xs text-gray-400">{{ item['propertyType'] }}</div>
                      </div>
                      <div class="flex flex-col justify-end text-gray-800 text-base">
                        <div>{{ item['price'] ? '€' + item['price'].toFixed(2) : '' }}</div>
                      </div>
                    </div>
                  </div>
                </a>
              </l-popup>
            </l-marker>
          </v-marker-cluster>

          <l-marker v-for="(item, index) in JSON.parse($attrs.locations)" :key="'marker-' + index"
            :options="{ type: item['type'] }" :lat-lng="[item['lat'], item['long']]"
            v-if="activeLocationFilter.length == 0 || activeLocationFilter.includes(item['type'])"
            :class="activeLocationFilter.length != 0 ? 'bigmarker' : ''"
            @click="scrollMarker(item['id']), showMarkerByIndex = null">
            <l-icon :icon-anchor="staticAnchor"
              class-name="markerClass noCluster !mt-0 !ml-0 !flex gap-1 items-center relative">

              <div
                class="icon w-2 h-2 shadow-md border-2 border-white dark:border-neutral-700 rounded-full flex items-center justify-center"
                :class="[
                  item['type'] && item['type'] == 'must_see' ? 'bg-indigo-400 text-indigo-400' :
                    item['type'] && item['type'] == 'amusement' ? 'bg-rose-400 text-rose-400' :
                      item['type'] && item['type'] == 'food_and_drinks' ? 'bg-amber-500 text-amber-500' :
                        item['type'] && item['type'] == 'parking' ? 'bg-blue-400 text-blue-400' :
                          item['type'] && item['type'] == 'shopping' ? 'bg-yellow-400 text-yellow-400' :
                            'bg-gray-500 text-gray-500'
                ]" :id="'marker-' + item['id']">
                <span class="flex items-center justify-center">
                  <svg-vue v-if="item['type'] == 'must_see'" class="w-5 h-5" icon="camera"></svg-vue>
                  <svg-vue v-else-if="item['type'] == 'food_and_drinks'" class="w-5 h-5" icon="food"></svg-vue>
                  <svg-vue v-else-if="item['type'] == 'amusement'" class="w-5 h-5" icon="amusement"></svg-vue>
                  <svg-vue v-else-if="item['type'] == 'parking'" class="ml-[2px] w-5 h-5" icon="parking"></svg-vue>
                  <svg-vue v-else-if="item['type'] == 'shopping'" class="w-5 h-5" icon="shopping"></svg-vue>
                  <svg-vue v-else class="w-5 h-5" icon="location"></svg-vue>
                </span>
              </div>
              <div class="marker_text max-w-[100px] absolute left-[calc(100%+0.3rem)] w-max" :class="[
                item['type'] && item['type'] == 'must_see' ? 'text-indigo-600 dark:text-indigo-200' :
                  item['type'] && item['type'] == 'amusement' ? 'text-rose-600 dark:text-rose-200' :
                    item['type'] && item['type'] == 'food_and_drinks' ? 'text-amber-700 dark:text-amber-200' :
                      item['type'] && item['type'] == 'parking' ? 'text-blue-600 dark:text-blue-200' :
                        item['type'] && item['type'] == 'shopping' ? 'text-yellow-600 dark:text-yellow-200' :
                          'bg-gray-500 text-gray-500'
              ]">{{ getTranslated(item['name']) }}</div>
            </l-icon>
            <l-popup>
              <a :href="`${currentUrl}/locations/${item.slug}?${params}`">
                <div class="flex flex-col justify-between items-start w-full">
                  <img v-bind:src="item['image_link']" alt="" loading="lazy"
                    class="w-full h-40 rounded-t-lg text-gray-200 object-cover" srcset="" />
                  <div class="flex justify-between items-end gap-2 w-full p-3">
                    <div class="flex flex-col gap-1">
                      <div class="text-sm text-gray-600">{{ getTranslated(item['name']) }}</div>
                      <div class="text-xs text-gray-400">{{ item['propertyType'] }}</div>
                    </div>
                    <div class="flex text-gray-800 text-base">
                      {{ item['price'] ? '€' + item['price'].toFixed(2) : '' }}
                    </div>
                  </div>
                </div>
              </a>
            </l-popup>
          </l-marker>
          <l-control-zoom position="topright"></l-control-zoom>

        </l-map>
      </div>
    </div>
  </div>
</template>



<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LControlZoom } from "vue2-leaflet";
import moment from "moment";
import VueCookies from 'vue-cookies'
import Leaflet from "../leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlZoom,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
  },
  data() {
    return {
      sortBy: "name",
      keyword: "",
      defaultPos: JSON.parse(this.$attrs.default_pos) ?? [0, 0, 0],
      page: 1,
      list: [],
      showMarkerByIndex: null,
      activeLocationFilter: [],
      staticAnchor: [16, 37],
      dataloaded: false,
      url: "https://tile.jawg.io/241a2530-2ad8-4bbe-b7ab-cc3dc94c489b/{z}/{x}/{y}{r}.png?access-token=vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa",
      darkurl: "https://tile.jawg.io/2d25a5ef-17c9-478a-818e-e89646afe989/{z}/{x}/{y}{r}.png?access-token=vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa",
      attribution:
        '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      zoom: 13,
      currentZoom: JSON.parse(this.$attrs.default_pos)[2] ?? 10,
      maxNativeZoom: 18,
      maxZoom: 20,
      minZoom: Number(this.$attrs.min_zoom) ?? 4,
      accessToken: 'vFzDRJ0kKfQsGhrWgc5NGVucII5tbQCySVMLnULzyyR54PZgfQsmNnY3quSTAQGa',
      markers: [],
      currentUrl: "",
      center: { 'latitude': 0, 'longitude': 0 },
      defaultCenter: { 'latitude': 0, 'longitude': 0 },
      markerinView: "",
      centerOffset: [0, 0],
      listingsTranslation: this.$t('Listings'),
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      params: [],
      singleCountry: false,
      search: new URLSearchParams(window.location.search),
      clusterOptions: {
        spiderfyDistanceMultiplier: 3,
        animate: true,
        animateAddingMarkers: true,
        showCoverageOnHover: false,
        averageCenter: true,
        ignoreHidden: true,
        singleMarkerMode: true,
        iconCreateFunction: function (cluster) {
          var children = cluster.getAllChildMarkers();
          var extraClass = '';
          if (children.length > 2) {
            extraClass = 'more'
          }

          var cheapestPrice = 10000000;
          for (let i = 0; i < children.length; i++) {
            if (Number(children[i].options.price) != 0 && Number(children[i].options.price) < cheapestPrice) {
              cheapestPrice = Number(children[i].options.price);
            }
          }
          if (cheapestPrice == 10000000) {
            return new L.DivIcon({ html: '<div><span><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 py-1 inline" fill="currentColor" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/></svg></span></div>', className: 'marker-cluster expand text-gray-500' + extraClass, iconSize: new L.Point(40, 40) });
          }
          return new L.DivIcon({ html: '<div><span>€ ' + cheapestPrice + '</span></div>', className: 'marker-cluster ' + extraClass, iconSize: new L.Point(40, 40) });
        },
      },
    };
  },
  mounted() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    getTranslated(n) {
      if (document.documentElement.lang in n) {
        return n[document.documentElement.lang]
      } else {
        return n['en']
      }
    },
    addOrRemoveFilter(item) {
      if (item == 'all') {
        if (this.activeLocationFilter.length == 0) {
          this.activeLocationFilter = ['listings'];
        } else {
          this.activeLocationFilter = [];
        }
      } else {
        if (this.activeLocationFilter.includes(item)) {
          var index = this.activeLocationFilter.indexOf(item);
          this.activeLocationFilter.splice(index, 1);
        } else {
          this.activeLocationFilter.push(item);
        }
      }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      var Xoffset = 0;
      var Yoffset = 0;
      if (this.windowWidth > 768) {
        Xoffset = 0;
        Yoffset = 0;
      } else {
        Xoffset = 0;
        Yoffset = -(0.4 * this.windowHeight) * 0.5;;
      }
      this.centerOffset = [Xoffset, Yoffset];
    },
    zoomUpdated(e) {
      this.currentZoom = e;
    },
    mipmap(src, res) {
      if (src) {
        if (src.includes('https://media.xmlcal.com')) {
          var imgblocks = src.split("/");
          var imgfile = imgblocks[imgblocks.length - 1];
          var thumbnailimgsmall =
            imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
          imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
          return imgblocks.join("/");
        } else {
          return src;
        }
      } else {
        return src;
      }
    },

    infiniteHandler($state) {
      axios.get(
        this.$BMB_API +'api/' +
        this.$clientID +
        "/getProperties" +
        window.location.search, {
        params: {
          getPrices: true,
          limit: 6,
          page: this.page,
        },
      }).then(({ data }) => {
        this.page += 1;
        this.list = { ...this.list, ...data.data }
        if (data.to != data.total) {
          $state.loaded();
        } else {
          $state.loaded();
          $state.complete();
        }
      });
    },
    clearSearch() {
      for (const [key, value] of this.search.entries()) {
        VueCookies.remove(key)
      }
      VueCookies.remove('propertyName')
      VueCookies.remove('checkin')
      VueCookies.remove('checkout')
      VueCookies.remove('country')
      VueCookies.remove('numChildren')
      VueCookies.remove('numAdult')
      VueCookies.remove('location')
      VueCookies.remove('accomodation')
      VueCookies.remove('city')
      window.location.href = this.currentUrl + '/accomodations/'
    },
    moveMap(id) {
      const map = this.$refs.map.mapObject;
      if (id != null) {
        if (id !== this.markerinView) {
          var marker = this.markers.find((element) => element['id'] === id);
          this.markerinView = id;
          var targetPoint = map.project([marker['latitude'], marker['longitude']], 15).subtract(this.centerOffset),
            targetLatLng = map.unproject(targetPoint, 15);

          map.setView(targetLatLng, 15);
        }
      }
    },
    centerMap() {
      const map = this.$refs.map.mapObject;
      var center = map.project([this.center['latitude'], this.center['longitude']]);
      center = new L.point(center.x - this.centerOffset[0], center.y - this.centerOffset[1]);
      var target = map.unproject(center);
      map.panTo(target);
    },
    scrollMarker(id) {
      this.markerinView = id;
      this.showMarkerByIndex = id;
    },
    maxDifference(arr) {
      let maxDiff = -1;
      let min = Number(arr[0]);
      for (let i = 0; i < arr.length; i++) {
        if (Number(arr[i]) > min && maxDiff < Number(arr[i]) - min) {
          maxDiff = Number(arr[i]) - min;
        }
        if (Number(arr[i]) < min) {
          min = Number(arr[i]);
        }
      }
      return maxDiff;
    },
    async getData() {
      if (!window.location.search) {
        try {
          let response = await fetch(
            this.$BMB_API +'api/' +
            this.$clientID +
            "/getProperties?showAll=True&getPrices=True",
            {
              headers: {
                "Content-Type": "text/plain",
                // "X-Requested-With": "XMLHttpRequest",
              },
            }
          );
          this.products = await response.json();

          this.dataloaded = true;
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          let response = await fetch(
            this.$BMB_API +'api/' +
            this.$clientID +
            "/getProperties" +
            window.location.search +
            "&getPrices=true",
            {
              headers: {
                "Content-Type": "text/plain",
              },
            }
          );
          this.products = await response.json();
          this.dataloaded = true;
        } catch (error) {
          console.log(error);
        }
      }

      if (this.products.data) {
        this.singleCountry = true;
        let currentCountry = this.products.data[0].country;

        for (let i = 0; i < this.products.data.length; i++) {
          if (this.products.data[i].country != currentCountry) {
            this.singleCountry = false;
          }
          this.markers.push({
            'latitude': this.products.data[i].latitude,
            'longitude': this.products.data[i].longitude,
            'id': this.products.data[i].id,
            'price': this.products.data[i].prices ? this.products.data[i].prices.price : null,
            'name': this.products.data[i].name,
            'propertyType': this.products.data[i].propertyType,
            'image': this.products.data[i].spotlightimage,
          });
        }
        let x = 0.0;
        let y = 0.0;
        let z = 0.0;

        var latestlatitude = this.markers[0]['latitude'];
        let latestlongitude = this.markers[0]['longitude'];

        var latitudes = [];
        var longitudes = [];
        for (let coord of this.markers) {
          let latitude = (coord['latitude'] * Math.PI) / 180;
          let longitude = (coord['longitude'] * Math.PI) / 180;

          latitudes.push(coord['latitude']);
          longitudes.push(coord['longitude']);
          x += Math.cos(latitude) * Math.cos(longitude);
          y += Math.cos(latitude) * Math.sin(longitude);
          z += Math.sin(latitude);
        }

        const latitudeDifference = this.maxDifference(latitudes);
        const longitudeDifference = this.maxDifference(longitudes);

        this.zoom = this.maxZoom - Math.max(latitudeDifference, longitudeDifference) - this.minZoom - 2;

        let total = this.markers.length;

        x = x / total;
        y = y / total;
        z = z / total;

        let centralLongitude = Math.atan2(y, x);
        let centralSquareRoot = Math.sqrt(x * x + y * y);
        let centralLatitude = Math.atan2(z, centralSquareRoot);

        var center = {
          'latitude': (centralLatitude * 180) / Math.PI,
          'longitude': (centralLongitude * 180) / Math.PI,
        };

        this.center = center
        this.defaultCenter = center;
      }
    },
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
    this.params = new URLSearchParams(document.location.search);
  },

  filters: {
    smallDate: function (date) {
      return moment(date).format('Do MMM');
    }
  },

  computed: {
    receivedAccos: function () {
      if (this.dataloaded) {
        return this.products.data;
      }
    },
    map_id() {
      return `map-${this._uid}`
    },
  },
};
</script>
